const apiUrl = process.env.REACT_APP_API_URL;
export const PostComandaModificacio = async (page: string, comandaModificacio: any[], id_comanda: number, id_usu_log: string) => {
    try {
        const response = await fetch(`${apiUrl}:8072/comanda/modificacio/${id_comanda}/${id_usu_log}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            },
            body: JSON.stringify(comandaModificacio)
        });
        if (!response.ok) {
            alert(await response.text());
        }

    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};